import React from 'react';
import { Box, TextField } from '@mui/material';
import { ButtonBlockData } from '../../../../models/courses';

interface ButtonBlockProps {
  data: ButtonBlockData;
  onChange: (_data: ButtonBlockData) => void;
  disabled?: boolean;
}

export const ButtonBlock: React.FC<ButtonBlockProps> = ({
  data,
  onChange,
  disabled,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      <TextField
        label="Текст кнопки"
        size="small"
        fullWidth
        value={data.text}
        onChange={(e) => onChange({ ...data, text: e.target.value })}
        disabled={disabled}
      />
      <TextField
        label="Ссылка кнопки"
        size="small"
        fullWidth
        placeholder="https://..."
        value={data.url}
        onChange={(e) => onChange({ ...data, url: e.target.value })}
        disabled={disabled}
      />
    </Box>
  );
};
